// src/components/RconHacking/RconHackingHeader.jsx
import React from 'react';

const RconHackingHeader = () => {
  return (
    // Add will-change to the outer div if it scales on hover (it currently doesn't, but good practice)
    <div className="mb-8 transform-gpu hover:scale-[1.01] transition-medium">
      {/* Add will-change to the main group container for internal group-hover effects */}
      <div
        className="relative overflow-hidden bg-gradient-to-r from-dark-500 via-dark-600 to-dark-500 rounded-2xl p-6 md:p-8 border border-dark-400 hover:border-accent-pink/30 transition-medium group"
      >
        {/* Background effects (add will-change if they animate complexly) */}
        <div className="absolute -right-20 -top-20 w-64 h-64 bg-accent-pink opacity-[0.03] rounded-full blur-3xl animate-pulse-slow group-hover:opacity-[0.06] transition-opacity duration-300"></div>
        <div className="absolute -left-20 -bottom-20 w-56 h-56 bg-accent-purple opacity-[0.03] rounded-full blur-3xl animate-pulse-slow group-hover:opacity-[0.06] transition-opacity duration-300"></div>

         <div className="flex flex-col md:flex-row items-center justify-between z-10 relative">
          {/* Left side: Text */}
          {/* Add will-change to elements with group-hover effects if needed */}
          <div className="w-full md:w-1/2 mb-6 md:mb-0 text-center md:text-left">
            <div className="inline-flex items-center text-sm font-medium text-accent-pink mb-2 animate-pulse-slow bg-accent-pink/10 px-3 py-1 rounded-full">
              <i className="fas fa-terminal mr-2"></i>
              RCON HACKING MODULE
            </div>
            {/* Apply directly to text if group hover affects it */}
            <h2 className="text-3xl font-bold mb-3 group-hover:text-white transition-colors">
              Remote Console
              <span className="gradient-text inline-block ml-2 group-hover:animate-pulse-text">Access</span>
            </h2>
            <p className="text-gray-400 text-sm max-w-md mx-auto md:mx-0 group-hover:text-gray-300 transition-colors">
              Scan for open RCON ports and attempt to brute-force passwords using comprehensive wordlists. Connect to a server below.
            </p>
          </div>

          {/* Right side: RCON Themed Graphic */}
          {/* Apply will-change to the container that scales */}
            <div
              className="w-full md:w-1/2 md:pl-8 flex items-center justify-center mt-6 md:mt-0 opacity-60 md:opacity-100 group-hover:opacity-100 transition-opacity duration-300"
            >
            <div
              className="relative w-48 h-48 group-hover:scale-105 transition-transform duration-500"
            >
               {/* Terminal Screen */}
               <div className="absolute inset-0 bg-dark-700 rounded-lg border border-accent-pink/30 shadow-lg overflow-hidden p-2">
                  <div className="absolute top-2 left-2 flex space-x-1.5">
                     <div className="w-2 h-2 rounded-full bg-accent-red"></div>
                     <div className="w-2 h-2 rounded-full bg-accent-yellow"></div>
                     <div className="w-2 h-2 rounded-full bg-accent-green"></div>
                  </div>
                  <div className="absolute bottom-2 left-2 text-accent-pink text-[8px] font-mono animate-pulse-slow">
                    root@mcsec:~# <span className="animate-pulse">█</span>
                  </div>
                  {/* Network lines */}
                   <div className="absolute top-1/3 left-1/4 w-0.5 h-8 bg-accent-purple animate-pulse-slow delay-100"></div>
                   <div className="absolute top-1/2 right-1/4 w-0.5 h-12 bg-accent-purple animate-pulse-slow delay-300"></div>
               </div>
               {/* Key Icon */}
               {/* Add will-change to animated elements */}
               <div className="absolute -bottom-4 -right-4 text-accent-purple text-5xl opacity-50 animate-float delay-500">
                    <i className="fas fa-key"></i>
               </div>
                {/* Lock Icon */}
               <div className="absolute -top-4 -left-4 text-accent-pink text-4xl opacity-40 animate-float">
                    <i className="fas fa-lock"></i>
               </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RconHackingHeader;